import { defineStore } from 'pinia';
import { computed, ref } from '@nuxtjs/composition-api'


export const useDiscountStore = defineStore('discountStore', () => {
  const latestDiscountCalculation = ref({});
  const getLatestDiscountCalculation = computed(() => latestDiscountCalculation);
  const setDiscountCalculation = (value) => {
    latestDiscountCalculation.value = value
  };
  return {
    getLatestDiscountCalculation,
    setDiscountCalculation
  }
})
